<template>
  <div class="dashboard">
    <va-card>
      <div class="row row-inside">
        <div class="flex xs6 md2">
          <va-input
            :value="nomRe"
            placeholder="Nom, SIRET, CP, Ville, Gérant"
            removable
            @input="searchNom"
          >
            <va-icon
              name="fa fa-search"
              slot="prepend"
            />
          </va-input>
        </div>
        <div class="flex md7">
          <div class="row row-inside align--center">
            <va-button-toggle
              outline
              small
              color="info"
              class="toggle-activite"
              v-model="entrepriseType"
              :options="optionsType"
            />
            <va-button-toggle
              outline
              small
              color="info"
              class="toggle-activite"
              v-model="documentFilter"
              :options="optionsDocument"
            />
            <h5
              class="selection-nb-title mx-3"
              :style="{ color: this.$themes['info'] }"
            >
              Sélectionnés : {{ entreprises.length }}
            </h5>
            <va-popover
              message="Rafraichir"
              placement="top"
            >
              <va-button
                class="selection-refresh"
                flat
                large
                color="info"
                icon="fa fa-refresh"
                @click="getEntreprises()"
              />
            </va-popover>
          </div>
        </div>

      </div>
      <div class="row row-inside">
        <div class="flex md12">
          <va-data-table
            class="va-table--hoverable va-table--stripped"
            :fields="fields"
            :data="entreprises"
            no-data-label="Aucune entreprise trouvée"
            :per-page="parseInt(perPage)"
            @row-clicked="openEntreprise"
            clickable
          >

            <template
              slot="document"
              slot-scope="props"
            >
              <div class="document-content">
                <va-button
                  class="document-button"
                  icon="fa fa-file"
                  :color="colorDocument(props.rowData)"
                  @click.stop="openDocument(props.rowData)"
                > Documents RNE {{ props.rowData.idformation_rne? moment(props.rowData.date_document).format('DD/MM/YYYY') : '' }} </va-button>
              </div>

            </template>

            <template
              slot="formations"
              slot-scope="props"
            >

              <div
                v-for="formation in convertFormationsList(props.rowData.formations)"
                :key="formation.idformation"
                @click.stop="openFormation(formation)"
              >
                <p class="formation-text">{{ formation.date }} {{ formation.nom }}</p>
              </div>

            </template>

          </va-data-table>
        </div>
      </div>
      <div class="flex xs12 md1 offset--md11">
        <div class="row row-inside">
          <va-button
            class="create-button"
            @click="createEntreprise()"
          >
            <va-icon
              size="30px"
              name="fa fa-plus"
            />
          </va-button>
        </div>
      </div>
    </va-card>

    <create-entreprise
      v-model="showCreateEntreprise"
      :identreprise="selectedIdentreprise"
      @create="updateList"
      @update="updateList"
      @delete="updateList"
    />

    <documents-formation-entreprise
      v-model="showDocument"
      :identreprise="identrepriseDocument"
    />
  </div>
</template>
  
  <script>
import axios from "axios";
import moment from "moment";
import { cloneDeep, debounce, findIndex, deburr } from "lodash";
import CreateEntreprise from "./components/create-entreprise.vue";
import Documents from "./components/documents.vue";
moment.locale("fr");

export default {
  name: "liste_entreprises_afpf",
  props: ["identreprise"],
  components: {
    "create-entreprise": CreateEntreprise,
    "documents-formation-entreprise": Documents,
  },
  data() {
    return {
      moment: moment,
      entreprisesRaw: [],
      perPage: 10,
      showCreateEntreprise: false,
      selectedIdentreprise: null,
      isaction: false,
      nomRe: null,
      optionsType: [
        { label: "Toutes", value: "all" },
        { label: "AFPF", value: "afpf" },
        { label: "Formations à venir", value: "fav" },
        { label: "Toute formation", value: "tf" },
      ],
      entrepriseType: "afpf",
      identrepriseDocument: null,
      showDocument: false,
      documentFilter: 'all',
      optionsDocument: [
        { label: "Tous", value: "all" },
        { label: "Avec RNE", value: "with_rne" },
        { label: "RNE valide", value: "valid_rne" },
        { label: "RNE expiré", value: "expired_rne" },
        { label: "Sans RNE", value: "without_rne" },
      ],

    };
  },
  methods: {
    colorDocument(entreprise) {
      if (!entreprise.idformation_rne) {
        return "danger";
      } else if (moment(entreprise.date_document).isAfter(moment().subtract(3, 'months'))) {
        return "success";
      } else {
        return "warning";
      }
    },
    openDocument(entreprise) {
      this.identrepriseDocument = entreprise.identreprise;
      this.showDocument = true;
    },
    createEntreprise() {
      console.log("createEntreprise")
      this.selectedIdentreprise = null;
      this.showCreateEntreprise = true;
    },
    updateList() {
      this.getEntreprises();
    },
    async openFicheEntreprise(identreprise) {

      await this.getEntreprises();

      let entreprise = this.entreprises.find(e => e.identreprise == identreprise)
      if (!entreprise) {
        this.launchEpicmaxToast("Entreprise non trouvée");
        this.$router.push({
          name: "entreprises-afpf",
        });
        return;
      }

      this.selectedIdentreprise = entreprise.identreprise;
      this.showCreateEntreprise = true;
    },

    openFormation(formation) {

      this.$router.push({
        name: "liste-formations",
        params: { idformation: formation.idformation },
      });
    },
    convertFormationsList(formations) {
      if (!formations) return [];
      return formations.split(',').map(f => ({ date: moment(f.trim().split('$')[0]).format("DD/MM/YYYY"), nom: f.trim().split('$')[1], idformation: f.trim().split('$')[2] }));
    },
    closeViewer() {
      this.$router.push({
        name: "entreprises-afpf",
      });
    },
    async getEntreprises() {
      const response = await axios.get('/api/afpf/entreprises-afpf', {
        params: { entrepriseType: this.entrepriseType },
      })

      let rawData = response.data;
      this.entreprisesRaw = rawData;
    },
    openEntreprise(entreprise) {
      console.log("openEntreprise", entreprise.identreprise)

      this.$router.push({
        name: "entreprises-afpf",
        params: { identreprise: entreprise.identreprise },
      });

    },
    searchNom: debounce(function (nomRe) {
      this.nomRe = nomRe;
    }, 400),
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
  },
  created() {
    this.getEntreprises();
  },
  mounted() { },
  computed: {
    entreprises() {
      let filteredData = this.entreprisesRaw;

      filteredData = filteredData.filter((item) => {
        if (!this.nomRe) return true;
        const searchTerm = deburr(this.nomRe.toLowerCase());
        return (
          (item.nom && deburr(item.nom.toLowerCase()).includes(searchTerm)) ||
          (item.siret && deburr(item.siret.toLowerCase()).includes(searchTerm)) ||
          (item.code_postal && deburr(item.code_postal.toLowerCase()).includes(searchTerm)) ||
          (item.ville && deburr(item.ville.toLowerCase()).includes(searchTerm)) ||
          (item.gerant && deburr(item.gerant.toLowerCase()).includes(searchTerm))
        );
      });

      if (this.documentFilter === 'with_rne') {
        filteredData = filteredData.filter(item => item.idformation_rne);
      } else if (this.documentFilter === 'valid_rne') {
        filteredData = filteredData.filter(item => item.idformation_rne && moment(item.date_document).isAfter(moment().subtract(3, 'months')));
      } else if (this.documentFilter === 'expired_rne') {
        filteredData = filteredData.filter(item => item.idformation_rne && moment(item.date_document).isBefore(moment().subtract(3, 'months')));
      } else if (this.documentFilter === 'without_rne') {
        filteredData = filteredData.filter(item => !item.idformation_rne);
      }

      return filteredData;
    },
    fields() {
      return [
        {
          name: "nom",
          title: "Enseigne",
          sortField: "nom",
          width: "10%",
        },
        {
          name: "siret",
          title: "SIRET",
          sortField: "siret",
          width: "10%",
        },
        {
          name: "code_postal",
          title: "Code Postal",
          sortField: "code_postal",
          width: "10%",
        },
        {
          name: "ville",
          title: "Ville",
          sortField: "ville",
          width: "10%",
        },
        {
          name: "gerant",
          title: "Gérant",
          sortField: "gerant",
          width: "10%",
        },
        {
          name: "__slot:document",
          title: "Documents",
          width: "10%",
        },
        {
          name: "__slot:formations",
          title: "Formations",
          width: "10%",
        },
      ]
    }
  },
  watch: {
    entrepriseType(newValue, oldValue) {
      if (newValue === oldValue) return;
      this.getEntreprises();

    },
    showCreateEntreprise(newValue, oldValue) {
      if (!newValue && oldValue) {
        this.closeViewer();
      }
    },
    identreprise: {
      immediate: true,
      handler(newvalue) {
        if (newvalue) {
          console.log("test", newvalue)
          this.openFicheEntreprise(newvalue);
        } else {
          console.log("test")
          this.showCreateEntreprise = false;
        }
      },
    }
  },
};
  </script>
  
  <style lang="scss">
.row-equal .flex {
  .va-card {
    height: 100%;
  }
}
.dashboard {
  .va-card {
    margin-bottom: 0;
  }
}

.formation-text {
  cursor: pointer;
  padding: 5px;
}
.formation-text:hover {
  color: blue;
}
</style>
  
